
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/terms-use",
      function () {
        return require("private-next-pages/about/terms-use/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/terms-use"])
      });
    }
  